"use client";

import React, { useState, useRef, useEffect } from 'react';
import styles from "./Accordion.module.scss"
import Image from 'next/image';

const Accordion = ({ items }) => {
  const [openIndex, setOpenIndex] = useState(null);
  // const [isActive, setIsActive] = useState(false);
  // const isActive = index === activeIndex;

  // const handleClick = () => {
  //   setActiveIndex(isActive ? null : index);
  // };

  const contentRefs = useRef([]);

  useEffect(() => {
    contentRefs.current = contentRefs.current.slice(0, items.length);
  }, [items]);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      {items.map((item, index) => (
        <div className="accordion" key={index}>
          <div className="accordion_title" onClick={() => toggleAccordion(index)}>
            <h5>{item.title}</h5>
            <div className="accordion_btn">
              <button className={`arrow_btn`}>
                {openIndex === index ? (
                  <Image src="/icons/minus.svg" width={20} height={20} alt='Minus Icon' priority />
                ) : (
                  <Image src="/icons/plus.svg" width={20} height={20} alt='Plus Icon' priority />
                )}
              </button>
            </div>
          </div>
          <div
            ref={el => contentRefs.current[index] = el}
            className={`accordion_content ${openIndex === index ? "accordion_content_open" : ""}`}
            style={
              openIndex === index
                ? { maxHeight: contentRefs.current[index] ? contentRefs.current[index].scrollHeight : 'none' }
                : { maxHeight: 0 }
            }
          >
            <div className="accordion_content" dangerouslySetInnerHTML={{ __html: item.content }}></div>
          </div>
        </div >
      ))}
    </>
  );
};

export default Accordion;